import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static identifier: string;
  static setIdentifier(identifier: string) {
    this.identifier = identifier;
  }

  static targets = [
    "search",
    "section",
    "sectionContent",
    "sectionToggle",
    "item",
  ];

  declare readonly searchTarget: HTMLInputElement;
  declare readonly sectionTargets: HTMLElement[];
  declare readonly sectionContentTargets: HTMLElement[];
  declare readonly sectionToggleTargets: HTMLElement[];
  declare readonly itemTargets: HTMLElement[];

  connect() {
    // Auto-expand the section containing the active page
    this.sectionTargets.forEach((section) => {
      const hasActive = section.querySelector("[data-active='true']");
      if (hasActive) {
        this.expandSection(section);
      } else {
        this.collapseSection(section);
      }
    });
  }

  filter() {
    const query = this.searchTarget.value.toLowerCase().trim();

    this.sectionTargets.forEach((section) => {
      const items = section.querySelectorAll<HTMLElement>(
        "[data-docs-sidebar-target='item']",
      );
      let anyVisible = false;

      items.forEach((item) => {
        const title = (item.dataset.title || "").toLowerCase();
        const matches = !query || title.includes(query);
        item.style.display = matches ? "" : "none";
        if (matches) anyVisible = true;
      });

      section.style.display = anyVisible ? "" : "none";
      if (query && anyVisible) this.expandSection(section);
    });
  }

  toggleSection(event: Event) {
    const button = event.currentTarget as HTMLElement;
    const section = button.closest<HTMLElement>(
      "[data-docs-sidebar-target='section']",
    );
    if (!section) return;

    const content = section.querySelector<HTMLElement>(
      "[data-docs-sidebar-target='sectionContent']",
    );
    if (!content) return;

    const isExpanded = content.dataset.expanded === "true";
    if (isExpanded) {
      this.collapseSection(section);
    } else {
      this.expandSection(section);
    }
  }

  private expandSection(section: HTMLElement) {
    const content = section.querySelector<HTMLElement>(
      "[data-docs-sidebar-target='sectionContent']",
    );
    const chevron = section.querySelector<HTMLElement>("[data-chevron]");
    if (!content) return;
    content.dataset.expanded = "true";
    content.style.display = "";
    if (chevron) chevron.style.transform = "rotate(90deg)";
  }

  private collapseSection(section: HTMLElement) {
    const content = section.querySelector<HTMLElement>(
      "[data-docs-sidebar-target='sectionContent']",
    );
    const chevron = section.querySelector<HTMLElement>("[data-chevron]");
    if (!content) return;
    content.dataset.expanded = "false";
    content.style.display = "none";
    if (chevron) chevron.style.transform = "";
  }
}
